import React from 'react';
import { IoStarOutline } from '@react-icons/all-files/io5/IoStarOutline';

import { decorateComponent } from '../../documentComponents';
import { RaffleInspector } from './Inspector';
import { Raffle } from './Raffle';

export default decorateComponent(Raffle, 'block', {
  id: 'raffle',
  label: '래플',
  defaultProps: {
    groupId: '',
    children: [],
  },
  allowedParent: [
    'page',
    'block',
  ],
  renderIcon: () => <IoStarOutline />,
  renderInspector: RaffleInspector,
});
